// 登录成功后服务器返回的数据
export default class ILoginResult {
	deliveryId: string = ''
	token: string = ''
	idnumber: string = ''
	name: string = ''
	phoneNumber: string = ''
	registerTime: Date = new Date()
	status: number = 0
	statusAbnormal: any
	wxOpenid: string = ''
	wxHeadUrl: string = ''
}
